import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SidebarComponent } from './sidebar.component';
import { MenuModule } from '../menu/menu.module';

@NgModule({
    imports: [CommonModule, TranslateModule, MenuModule, SidebarComponent],
    exports: [SidebarComponent]
})
export class SidebarModule {}
